module.exports = __webpack_public_path__ + "img/sketch3.fdf27be5.jpg";